import { render, staticRenderFns } from "./SelectorTipoCobranca.vue?vue&type=template&id=67ed7cae&scoped=true"
import script from "./SelectorTipoCobranca.vue?vue&type=script&lang=js"
export * from "./SelectorTipoCobranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed7cae",
  null
  
)

export default component.exports